/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { useSetRecoilState } from "recoil";

import ismsImg from "@images/isms.png";
import { modalToggleIsmsState } from "@recoil";

import * as styles from "./isms.style";

export default function Isms() {
  const setIsmsOpen = useSetRecoilState(modalToggleIsmsState);

  const handleClick = () => {
    setIsmsOpen(true);
  };

  return <img css={styles.ismsImg} src={ismsImg} onClick={handleClick} />;
}
